import { METRIC_SELECTOR, ORDER } from './DataPanelConstants';

export const getMetricContent = (raw: string) => {
  const start = raw.indexOf('(');
  const end = raw.indexOf(')');
  const len = raw.length;
  if (start != -1 && end != -1) {
    let item = raw.substring(start + 1, end);
    if (item.indexOf(',') == -1) {
      item += ',all';
    }
    if (end < len) {
      item += ',' + raw.substring(end + 1, len);
    }
    return item;
  }
  return '';
};

export const getMetricFieldsByFullName = (fullName: string) => {
  if (fullName) {
    const nameArr = fullName.split(',');
    if (nameArr.length > 2) {
      nameArr.shift();
      nameArr.shift();
      return nameArr.join(',').trim();
    }
  }
  return '';
};

export const getMetricTypeByFullName = (fullName: string) => {
  if (fullName) {
    return fullName.split(',')[0];
  }
  return fullName;
};

export const getMetricSourceByFullName = (fullName: string) => {
  if (fullName && fullName.indexOf(',') != -1) {
    return fullName
      .split(',')[1]
      .trim()
      .replace(/^['"]|['"]$/g, '');
  }
  return METRIC_SELECTOR.ALLSOURCES;
};

export const getOrderType = (fullOrder: string): ORDER => {
  if (fullOrder.startsWith(ORDER.ASCENDING)) return ORDER.ASCENDING;
  else return ORDER.DESCENDING;
};

export const getOrderAlias = (fullOrder: string): string => {
  const contentSearch = fullOrder.match(/\((.*?)\)/);
  if (contentSearch) return contentSearch[1];
  return '';
};
